import { FORM_10_8678 } from './constants';

const { VHA_MEDICAL_FACILITY } = FORM_10_8678;

export const VHA_FACILITY_STATE_SCHEMA_KEY = 'x-vha-facility-state';

export const OTHER_VHA_MEDICAL_FACILITY_OPTION = {
  id: 'other',
  label: VHA_MEDICAL_FACILITY.OTHER_OPTION,
};

export const getVhaMedicalFacilityLabel = facility => {
  if (!facility) {
    return '';
  }

  if (typeof facility === 'string') {
    return facility;
  }

  return facility.label || facility.id || '';
};

export const isOtherVhaMedicalFacility = facility =>
  getVhaMedicalFacilityLabel(facility) === VHA_MEDICAL_FACILITY.OTHER_OPTION;
